import React from "react"
import ReactDOM from "react-dom"
import App from "./components/App"
import "@amzn/meridian-tokens/base/font/amazon-ember.css"
import { BrowserRouter } from "react-router-dom"
import { CookiesProvider } from "react-cookie"
import "./i18n/i18n"

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(reportHandler)
